<template>
  <v-card class="manage-students">
    <v-tabs
      v-model="currentChildTab"
      background-color="primary"
      icons-and-text
      slider-color="secondary"
      dark
    >
      <v-tab ripple>student list<v-icon x-large>group</v-icon></v-tab>
      <v-tab ripple>add new students<v-icon x-large>person_add</v-icon></v-tab>
      <v-tab ripple>print student list<v-icon x-large>print</v-icon></v-tab>
      <v-btn
        fab
        small
        color="white"
        outlined
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon dark>close</v-icon>
      </v-btn>
    </v-tabs>
    <v-tabs-items v-model="currentChildTab" touchless>
      <v-tab-item class="pa-3">
        <student-list :customClass="customClass" :in-class="true" />
      </v-tab-item>
      <v-tab-item class="pa-3 add-student-overflow">
        <add-students @changeTab="changeTab" />
      </v-tab-item>
      <v-tab-item class="pa-3">
        <print-students />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import StudentList from './StudentList'
import AddStudents from './AddStudents'
import PrintStudents from './PrintStudents'

export default {
  name: 'ManageStudents',
  components: {
    StudentList,
    AddStudents,
    PrintStudents
  },
  props: {
    customClass: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      newClass: false,
      currentChildTab: 0
    }
  },
  watch: {
    currentChildTab(val) {
      let query = Object.assign({}, this.$route.query)
      query.currentChildTab = val
      this.$router.push({ query: query })
    }
  },
  mounted() {
    this.currentChildTab = parseInt(this.$route.query.currentChildTab)
  },
  methods: {
    changeTab(v) {
      this.currentChildTab = v
    }
  }
}
</script>

<style lang="scss">
.manage-students {
  box-shadow: none;

  .close-button {
    position: absolute;
    right: 20px;
    top: 12px;

    @include breakpoint($xs) {
      position: relative;
      right: auto;
    }
  }

  .v-window__container--is-active {
    height: auto !important;
  }
}
</style>
